<script setup lang="ts">
import { provide, ref } from "vue";
import { locale } from "../../locale";
import GreetingPage from "../templates/GreetingPage.vue";
import { roomState } from "../../states/room";
import ChatRecordsBlock from "../../components/ChatRecordsBlock.vue";
import { isSelfAdmin } from "../../states/adminsState";
import { build_settings } from "../../assets/custom/settings";
const isLinks = ref<boolean>(false);
provide("isLinks", isLinks);

defineProps<{
  reason: "complete" | "tarifftime";
}>();
</script>
<template>
  <GreetingPage>
    <div class="blocks-wrapper">
      <div class="block">
        <div class="text">{{ locale.endPage.complete }}</div>
        <div class="completed">
          <div class="icon">
            <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24.1602" r="18" stroke="#8DCA35" stroke-width="2" />
              <path d="M16 24.8268L20.6506 29.3052C21.1463 29.7825 21.9306 29.7825 22.4263 29.3052L34 18.1602"
                stroke="#8DCA35" stroke-width="2" />
            </svg>
          </div>
          <div class="room-name">{{ roomState.name }}</div>
          <div v-if="reason === 'tarifftime'" class="tariff-text">
            <template v-if="build_settings.disable_tariff_feature">
              {{
                locale.endCallTarif.disabled
              }}
            </template>
            <template v-else-if="roomState.tarif === 'FREE'">{{
              locale.endCallTarif.free
              }}</template>
            <template v-else-if="roomState.tarif === 'PAY'">{{
              locale.endCallTarif.pay
              }}</template>
          </div>
        </div>
      </div>
      <ChatRecordsBlock v-if="isSelfAdmin"/>
    </div>
  </GreetingPage>
</template>
<style scoped>
.blocks-wrapper {
  display: flex;
  gap: 24px;
}

.block {
  width: 600px;
  height: 450px;
  display: flex;
  padding: 24px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  background: #fff;
  position: relative;
}

.room-name {
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 19.07px;
  text-align: center;
  text-overflow: ellipsis;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  padding: 0 24px;
}

.tariff-text {
  color: #747474;
  width: 100%;
  padding: 0 20px;
  text-align: center;

  font-family: Open Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
}

.completed {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  position: absolute;
  top: 187px;
}

.text {
  width: 100%;
  color: #292929;
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  position: absolute;
  top: 24px;
}
</style>
